import { render } from "./info.vue?vue&type=template&id=75c1a1d2&scoped=true&ts=true"
import script from "./info.vue?vue&type=script&lang=ts"
export * from "./info.vue?vue&type=script&lang=ts"

import "./info.vue?vue&type=style&index=0&id=75c1a1d2&lang=scss"
import "./info.vue?vue&type=style&index=1&id=75c1a1d2&lang=scss&scoped=true"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c1a1d2"]])

export default __exports__